import { RESOURCE } from '@src/constants';
import { omitIsNil } from '@src/utils/omit';
import api from './api';

const createVoiceCloningVoice = async ({
  categoryId,
  name,
  username,
  gender,
  avatar,
  locale,
  description,
  provinceId,
  instantVoiceId,
  type,
  ageGroup,
}) => {
  try {
    const response = await api({
      method: 'POST',
      url: `${RESOURCE.VOICE_CLONING}/voices`,
      data: {
        categoryId,
        name,
        username,
        gender,
        avatar,
        locale,
        description,
        provinceId,
        instantVoiceId,
        type,
        ageGroup,
      },
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

const getVoiceCloningVoices = async () => {
  try {
    const response = await api({
      method: 'GET',
      url: `${RESOURCE.VOICE_CLONING}/voices`,
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

const updateVoiceCloningVoice = async (voiceId, data) => {
  try {
    const response = await api({
      method: 'PUT',
      url: `${RESOURCE.VOICE_CLONING}/voices/${voiceId}`,
      data,
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

const getVoiceCloningCategories = async () => {
  try {
    const response = await api({
      method: 'GET',
      url: `${RESOURCE.VOICE_CLONING}/categories`,
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

const getVoiceCloningAudios = async (voiceId) => {
  try {
    const response = await api({
      method: 'GET',
      url: `${RESOURCE.VOICE_CLONING}/voices/${voiceId}/audios`,
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

const updateVoiceCloningAudio = async (audioId, data) => {
  try {
    const response = await api({
      method: 'PUT',
      url: `${RESOURCE.VOICE_CLONING}/audios/${audioId}`,
      data,
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

const getVoiceCloningVoice = async (voiceId) => {
  try {
    const response = await api({
      method: 'GET',
      url: `${RESOURCE.VOICE_CLONING}/voices/${voiceId}`,
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

const getVoiceCloningProvinces = async ({
  search,
  searchFields,
  offset,
  limit,
  fields,
  sort,
  locale,
}) => {
  try {
    const response = await api({
      method: 'GET',
      url: `${RESOURCE.VOICE_CLONING}/provinces`,
      params: {
        search,
        searchFields,
        offset,
        limit,
        fields,
        sort,
        locale,
      },
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

const getVoiceCloningVoiceSubmitCheck = async (voiceId) => {
  try {
    const response = await api({
      method: 'GET',
      url: `${RESOURCE.VOICE_CLONING}/voices/${voiceId}/submit-check`,
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

const deleteCloningVoice = async (voiceId) => {
  try {
    const response = await api({
      method: 'PUT',
      url: `${RESOURCE.VOICE_CLONING}/voices/delete`,
      data: {
        id: voiceId,
      },
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

const getMyVoicesCount = async () => {
  try {
    const response = await api({
      method: 'GET',
      url: `${RESOURCE.VOICE_CLONING}/voices/count`,
    });

    const { result } = response || {};

    return result;
  } catch (error) {
    return {};
  }
};

const getTrainingZeroShotProgress = async (instantVoiceId) => {
  try {
    const response = await api({
      method: 'GET',
      url: `${RESOURCE.VOICE_CLONING}/voices/${instantVoiceId}/training-zero-shot-progress`,
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

const publishVoice = async (voiceId, data) => {
  try {
    const response = await api({
      method: 'POST',
      url: `${RESOURCE.VOICE_CLONING}/voices/${voiceId}/publish`,
      data,
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

const checkVoiceNameExist = async ({ voiceId, name }) => {
  try {
    const response = await api({
      method: 'POST',
      url: `${RESOURCE.VOICE_CLONING}/voices/${voiceId}/check-name-exist`,
      data: {
        name,
      },
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

const getCommunityVoiceStats = async ({ startDate, endDate, search }) => {
  try {
    const params = omitIsNil({
      search,
      startDate,
      endDate,
    });
    const response = await api({
      method: 'GET',
      url: `/community-voice-stats`,
      params,
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

const getTotalWithdrawn = async () => {
  try {
    const response = await api({
      method: 'GET',
      url: `/voice-revenue-transactions/total-withdrawn`,
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

const sendWithdrawalRequest = async (data) => {
  try {
    const response = await api({
      method: 'POST',
      url: `/voice-revenue-transactions`,
      data,
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

const getProcessingWithdrawal = async () => {
  try {
    const response = await api({
      method: 'GET',
      url: `voice-revenue-transactions/in-processing`,
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

const cancelPublishVoice = async (voiceId) => {
  try {
    const response = await api({
      method: 'POST',
      url: `${RESOURCE.VOICE_CLONING}/voices/${voiceId}/waiting-public/cancel`,
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

const unpublishVoice = async (voiceId) => {
  try {
    const response = await api({
      method: 'POST',
      url: `${RESOURCE.VOICE_CLONING}/voices/${voiceId}/discard`,
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

const cancelUnpublishVoice = async (voiceId) => {
  try {
    const response = await api({
      method: 'POST',
      url: `${RESOURCE.VOICE_CLONING}/voices/${voiceId}/waiting-removal/cancel`,
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

const requestUpdateVoice = async (voiceId, data) => {
  try {
    const response = await api({
      method: 'POST',
      url: `${RESOURCE.VOICE_CLONING}/voices/${voiceId}/update-request`,
      data,
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

const cancelRequestUpdateVoice = async (voiceId) => {
  try {
    const response = await api({
      method: 'POST',
      url: `${RESOURCE.VOICE_CLONING}/voices/${voiceId}/update-request/cancel`,
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

const getTips = async () => {
  try {
    const response = await api({
      method: 'GET',
      url: `${RESOURCE.VOICE_CLONING}/tips`,
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

const getProfessionalSentences = async () => {
  const response = await api({
    method: 'GET',
    url: `${RESOURCE.VOICE_CLONING}/sentences/professional`,
  });
  return response;
};

const createVoiceCloningAudio = async ({
  audioLink,
  name,
  duration,
  size,
  type,
  voiceId,
  denoise,
}) => {
  try {
    const response = await api({
      method: 'POST',
      url: `${RESOURCE.VOICE_CLONING}/audios`,
      data: {
        audioLink,
        name,
        duration,
        size,
        type,
        voiceId,
        denoise,
      },
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

const checkAudioQuality = async (audioId, { denoise }) => {
  try {
    const response = await api({
      method: 'POST',
      url: `${RESOURCE.VOICE_CLONING}/audios/${audioId}/check-quality`,
      data: {
        denoise,
      },
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

const verificationVoice = async (voiceId, data) => {
  try {
    const response = await api({
      method: 'POST',
      url: `${RESOURCE.VOICE_CLONING}/voices/${voiceId}/verification`,
      data,
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

const updateAudioDenoise = async (audioId, denoise) => {
  try {
    const response = await api({
      method: 'PUT',
      url: `${RESOURCE.VOICE_CLONING}/audios/${audioId}/denoise`,
      data: {
        denoise,
      },
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

const deleteUploadedAudio = async (audioId) => {
  try {
    const response = await api({
      method: 'DELETE',
      url: `${RESOURCE.VOICE_CLONING}/audios/${audioId}`,
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

const getVoiceCloningAudio = async (audioId) => {
  try {
    const response = await api({
      method: 'GET',
      url: `${RESOURCE.VOICE_CLONING}/audios/${audioId}`,
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

const duplicateVoice = async ({ voiceId, name }) => {
  try {
    const response = await api({
      method: 'POST',
      url: `${RESOURCE.VOICE_CLONING}/voices/duplicate`,
      data: {
        voiceId,
        name,
      },
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

export {
  createVoiceCloningVoice,
  getVoiceCloningVoices,
  updateVoiceCloningVoice,
  getVoiceCloningCategories,
  getVoiceCloningAudios,
  updateVoiceCloningAudio,
  getVoiceCloningVoice,
  getVoiceCloningProvinces,
  getVoiceCloningVoiceSubmitCheck,
  deleteCloningVoice,
  getMyVoicesCount,
  getTrainingZeroShotProgress,
  publishVoice,
  checkVoiceNameExist,
  getCommunityVoiceStats,
  getTotalWithdrawn,
  sendWithdrawalRequest,
  getProcessingWithdrawal,
  cancelPublishVoice,
  unpublishVoice,
  cancelUnpublishVoice,
  requestUpdateVoice,
  cancelRequestUpdateVoice,
  getTips,
  getProfessionalSentences,
  createVoiceCloningAudio,
  checkAudioQuality,
  verificationVoice,
  updateAudioDenoise,
  deleteUploadedAudio,
  getVoiceCloningAudio,
  duplicateVoice,
};
